//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ExamenEdit from "./components/ExamenEdit"
import PreguntaEdit from "./components/PreguntaEdit"
import PreguntaCreate from "./components/PreguntaCreate"

export default {
  components: {
    ExamenEdit,
    PreguntaEdit,
    PreguntaCreate,
  },
  data() {
    return {
      showExamenEdit: false,
      showPreguntaAdd: false,
      showPreguntaEdit: false,
      examenes: [],
      examen: {},
      preguntas: [],
      selected: [],
      columns: [
        {
          name: "pregunta",
          label: "Pregunta",
          field: "frase",
          align: "left",
          classes: "bg-grey-2 ellipsis",
          headerClasses: "bg-primary text-white",
        },
        {
          name: "respuestas",
          label: "Respuestas",
          style: "width: 200px",
          format: (val, row) => Number(row.respuestas.length),
        },
        {
          name: "created_at",
          label: "Creación",
          field: "created_at",
          style: "width: 200px",
          format: this.momentFromNow,
        },
      ],
    }
  },

  computed: {
    hasSelected() {
      return !!this.selected.length
    },
  },

  watch: {
    // Hack: $router no detecta el cambio del parametro
    ["$route.params.examen"](examen) {
      this.loadExamen()
    },
  },

  mounted() {
    this.loadExamenes()
    this.loadExamen()
  },

  methods: {
    async loadExamen() {
      const { preguntas, ...examen } = await this.$store.dispatch("examen/get", this.$route.params.examen)
      this.examen = examen
      this.preguntas = preguntas
      this.$store.set("examen/seleccion", examen)
    },
    async loadExamenes() {
      this.examenes = await this.$store.dispatch("examen/all")
    },
    changeExamen(examen) {
      this.$router.push({ name: "examen", params: { examen } })
    },
    preguntaClick(pregunta) {
      this.$store.set("examen/pregunta/seleccion", pregunta)
      this.showPreguntaEdit = true
    },
    openExamenEdit() {
      this.showExamenEdit = true
      this.$store.set("examen/seleccion", this.examen)
    },
    submitUpdatedExamen(examen) {
      this.showExamenEdit = false

      this.examen = examen

      this.loadExamenes()
    },
    openPreguntaCreate() {
      this.$store.set("examen/seleccion", this.examen)
      this.showPreguntaAdd = true
    },
    async publish() {
      await this.$store.dispatch("examen/publicar", this.examen.id)
      this.loadExamen()
    },

    async unpublish() {
      await this.$store.dispatch("examen/no_publicar", this.examen.id)
      this.loadExamen()
    },

    submitPreguntaCreate(pregunta) {
      this.showPreguntaAdd = false
      this.loadExamen()
    },
    submitPreguntaEdit(pregunta) {
      this.showPreguntaEdit = false
      this.loadExamen()
    },

    confirmPreguntasDelete() {
      this.$q
        .dialog({
          title: "Eliminar preguntas",
          message:
            "Por favor, selecciona las preguntas que quieres eliminar, para confirmar." +
            " Esta acción no se puede deshacer.",
          cancel: true,
          options: {
            isValid: (val) => val.length > 0,
            type: "checkbox",
            model: [],
            items: this.selected.map((e) => ({ label: e.frase, value: e.id })),
          },
        })
        .onOk(this.deletePreguntas)
    },
    async deletePreguntas(preguntas) {
      const promises = preguntas.map(pregunta => this.$store.dispatch('examen/pregunta/delete', { examen: this.examen.id, pregunta}))

      await Promise.all(promises)

      this.loadExamen()
    },
  },
}
